import React, { useEffect, useRef, useState } from "react";
import { BASEURL } from "../config/config";
import { getS3Url } from "../utlity/utlityFunctions";
import { SafeImage } from "./helper/SafImage";
import { Volume2, VolumeX } from "lucide-react";

function PostMedia({
  item,
  muted,
  setMuted,
  activeFullScreenPost,
  setActiveFullScreenPost,
}) {
  const videoRef = useRef(null);
  const containerRef = useRef(null);
  // const [fullScreen, setFullScreen] = useState(false);
  const fullScreen = activeFullScreenPost === item._id;
  const getFileUrl = (photo) => {
    if (!photo) return "/images/user.png";

    return photo.includes("/public/") ? `${BASEURL}${photo}` : getS3Url(photo);
  };

  const isVideo = (url) => /\.(mp4|mov|webm|ogg)$/i.test(url);

  const fileUrl = getFileUrl(item?.photo);
  const video = isVideo(fileUrl);

  useEffect(() => {
    if (!video || !videoRef.current || !containerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (
          entry.isIntersecting &&
          (!activeFullScreenPost || activeFullScreenPost === item._id)
        ) {
          videoRef.current.play().catch(() => {});
        } else {
          videoRef.current.pause();
        }
      },
      {
        threshold: 0.7,
      },
    );

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [video, activeFullScreenPost]);

  useEffect(() => {
    if (!videoRef.current) return;

    if (activeFullScreenPost) {
      if (activeFullScreenPost === item._id) {
        videoRef.current.play().catch(() => {});
      } else {
        videoRef.current.pause();
      }
    }
  }, [activeFullScreenPost, item._id]);

  useEffect(() => {
    if (fullScreen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [fullScreen]);

  const handleImageLoad = (e) => {
    const img = e.target;
    const container = img.parentElement;
    container.style.paddingTop = `${
      (img.naturalHeight / img.naturalWidth) * 100
    }%`;
  };

  return (
    <div
      ref={containerRef}
      className={`post-img-container ${fullScreen ? "fullscreen-mode" : ""}`}
      onClick={(e) => {
        e.stopPropagation();
        // setFullScreen(true);
        setActiveFullScreenPost(item._id);
        setMuted(!muted);
      }}
      // className="post-img-container"
    >
      {video ? (
        <div>
          <video
            ref={videoRef}
            src={fileUrl}
            className="post-img"
            muted={muted}
            loop
            playsInline
          />

          <button
            onClick={(e) => {
              e.stopPropagation();
              setMuted(!muted);
            }}
            style={{
              position: "absolute",
              bottom: "10px",
              right: "10px",
              zIndex: 10, // Higher z-index ensures it stays on top of the video
              border: "none",
              backgroundColor: "rgba(0, 0, 0, 0.6)", // Semi-transparent looks more professional
              color: "white",
              borderRadius: "50%",
              width: "40px", // Increased size for playability
              height: "40px", // Increased size
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
          </button>
        </div>
      ) : (
        <SafeImage
          src={fileUrl}
          className="post-home-img"
          alt="Post"
          loading="lazy"
          onLoad={handleImageLoad}
        />
      )}
      {fullScreen && (
        <button
          className="close-fullscreen"
          onClick={(e) => {
            e.stopPropagation();
            // setFullScreen(false);
            setActiveFullScreenPost(null);
            setMuted(true);
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
}

export default PostMedia;
